import { useEffect, useLayoutEffect, useRef, useState } from "react";
import Utils from "../utils";

const ColumnBook = ({ script, onClick }) => {
  const isSampleScript = Utils.isSampleScript(script)

  return <button className="fairytales-book" type="button"
    aria-label={`${script.title} ${isSampleScript ? '미리보기' : '읽기'}`}
    onClick={() => onClick(script.scriptNo, isSampleScript)}>
    <span className={`fairytales-book-cover${script.mainImageUrl ? '' : ' fairytales-book-cover--placeholder'}`}>
      <img src={script.mainImageUrl ? script.mainImageUrl + "?300" : '/image/main/books.png'} alt="" loading="lazy" width="300" height="254" />
      {isSampleScript && <span className="fairytales-sample-badge">미리보기</span>}
    </span>
    <span className="fairytales-book-copy">
      <span className="fairytales-book-title">{script.title}</span>
      <span className="fairytales-book-summary">{script.summary}</span>
      <span className="fairytales-book-action">동화 읽기 <span aria-hidden="true">↗</span></span>
    </span>
  </button>
}

const PAGE_SIZE = 4

const PendingBook = ({ number }) => <article className='fairytales-book fairytales-book--pending' aria-label={`생성 중인 동화 ${number}`}>
  <div className='fairytales-book-cover fairytales-book-cover--pending'>
    <span className='fairytales-pending-badge'>생성 중</span>
    <img src='/image/main/books.png' alt='' width='64' height='64' />
    <span className='fairytales-pending-dots' aria-hidden='true'><span /><span /><span /></span>
  </div>
  <div className='fairytales-book-copy'>
    <h3 className='fairytales-book-title'>새로운 이야기를<br />만들고 있어요</h3>
    <p className='fairytales-book-summary'>아이만의 특별한 동화를 준비하고 있어요.</p>
    <span className='fairytales-book-action'>완성되면 읽을 수 있어요 <span aria-hidden='true'>✧</span></span>
  </div>
</article>

const BookColumnList = ({ scripts = [], pendingStoryCount = 0, onBookClick, initialVisibleScriptNo }) => {

  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)
  const targetBookRef = useRef(null)
  const hasAutoScrolledRef = useRef(false)

  useEffect(() => {
    hasAutoScrolledRef.current = false
  }, [initialVisibleScriptNo])

  useLayoutEffect(() => {
    if (!initialVisibleScriptNo) {
      setVisibleCount(PAGE_SIZE)
      return
    }

    const targetScriptNo = Number(initialVisibleScriptNo)
    const targetIndex = scripts?.findIndex(script => Number(script.scriptNo) === targetScriptNo) ?? -1

    if (!Number.isFinite(targetScriptNo) || targetIndex < 0) {
      setVisibleCount(PAGE_SIZE)
      return
    }

    setVisibleCount(Math.max(PAGE_SIZE, Math.ceil((targetIndex + 1) / PAGE_SIZE) * PAGE_SIZE))
  }, [scripts, initialVisibleScriptNo])

  useEffect(() => {
    if (!initialVisibleScriptNo || hasAutoScrolledRef.current) return

    const targetScriptNo = Number(initialVisibleScriptNo)
    const targetIndex = scripts?.findIndex(script => Number(script.scriptNo) === targetScriptNo) ?? -1

    if (!Number.isFinite(targetScriptNo) || targetIndex < 0 || targetIndex >= visibleCount) return
    if (!targetBookRef.current) return

    hasAutoScrolledRef.current = true
    targetBookRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, [scripts, visibleCount, initialVisibleScriptNo])

  const visibleScripts = scripts.slice(0, visibleCount)
  const visiblePendingCount = Math.min(pendingStoryCount, Math.max(0, visibleCount - scripts.length))
  const totalStoryCount = scripts.length + pendingStoryCount
  const hasMore = visibleCount < totalStoryCount

  return <>
    <ul className='fairytales-book-grid'>
    {
      visibleScripts && visibleScripts.map(script => {
        const isTargetScript = Number(script.scriptNo) === Number(initialVisibleScriptNo)

        return <li key={script.scriptNo} ref={isTargetScript ? targetBookRef : null}>
          <ColumnBook
            script={script}
            onClick={onBookClick}
          />
        </li>
      })
    }
    {Array.from({ length: visiblePendingCount }, (_, index) => <li key={`pending-${index}`}>
      <PendingBook number={index + 1} />
    </li>)}
    </ul>
    {
      hasMore && <div className='fairytales-more'>
        <p>{visibleScripts.length + visiblePendingCount} / {totalStoryCount}편의 이야기</p>
        <button className='book-secondary-button'
          type='button'
          onClick={() => setVisibleCount(count => count + PAGE_SIZE)}>
          이야기 더 보기 <span aria-hidden='true'>＋</span>
        </button>
      </div>
    }
  </>
}

export default BookColumnList
